
import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import PickItem from './PickItem'
import { Thunderbolt } from 'react-bootstrap-icons';
import * as MySound from '../MySound';

export class PickLocation extends Component {
    static displayName = PickLocation.name;
    constructor(props) {
        super(props);
        this.state = {
            loading: false, alertMessage: "", currentPickInfo: props.location.state, pickData: null, locationBarcode: "", locationBarcodeVerified: false, locationVeficationMsg: "", isPickingShorts: false
        };
        this.history = props.history;
        this.nextItem = 0;
        this.nextLocation = 1;
        this.pickStageId = "";
    }
    componentDidMount() {
        if (typeof this.state.currentPickInfo.pickData === 'undefined') {
            this.getNextPickLocation(this.nextItem, this.pickStageId); 
        }
        else {
            var isPickingShorts = false;
            if (typeof this.state.currentPickInfo.isPickingShorts !== 'undefined') {
                isPickingShorts = this.state.currentPickInfo.isPickingShorts;
            }
            this.setState({ pickData: this.state.currentPickInfo.pickData, isPickingShorts: isPickingShorts });
        }
    }

    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }
    render() {
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        const handlebarcodeKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.verifyLocation();
            }
        };

        let alertMessage = this.state.alertMessage;

        return (
            <>
                {this.state.loading && <div className="p1"> <em>  Loading next pick location ... </em></div>}
                {alertMessage.length > 0 &&
                    <>
                        <MyAlert variant="danger">{alertMessage}</MyAlert>
                        <Button variant="success" onClick={() => { this.goto('MHEWithPickRows', { selectedPick: this.state.currentPickInfo.selectedPickInfo }); }} >Back</Button>
                    </>
                }
                {this.state.pickData !== null && !this.state.locationBarcodeVerified &&
                    <div className="text-center">
                        <h3>Pick</h3>
                        <h5>{this.state.currentPickInfo.pickNumber}</h5>
                        <h1>{this.state.pickData.locationBarcode}</h1>
                        <label>Enter Location on Arrival to Pick</label>
                        <InputGroup size="lg" className="row d-flex justify-content-center mb-3">
                            <FormControl autoFocus="autofocus" ref="barcodeScanInput" className="col-7 form-control text-center font-weight-bold" onInput={toInputUppercase}
                                value={this.state.locationBarcode}
                                onChange={(e) => {
                                    this.setState({ locationBarcode: e.target.value });
                                }}
                                onKeyPress={handlebarcodeKeyPress}
                            />
                        </InputGroup>
                    </div>
                }
                {this.state.locationVeficationMsg.length > 0 && !this.state.locationBarcodeVerified && <MyAlert variant="danger" >{this.state.locationVeficationMsg}</MyAlert>}
                {this.state.pickData !== null && !this.state.locationBarcodeVerified &&
                    <div className="text-center">
                        <Button variant="success" className="m-3" onClick={() => { this.goBackToPickList() }}>Back</Button>
                        <Button variant="success" className="m-3" onClick={() => { this.skipLocation() }} disabled={this.state.currentPickInfo.isPickingShorts}>Skip</Button>
                        <Button variant="success" className="m-3" onClick={() => { this.verifyLocation() }}>Next</Button>
                    </div>
                }
            </>
        );
    }

    getNextPickLocation(nextPickType, pickStageId) {
        this.setState({ loading: true });
        const nextPickRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                PickNumber: this.state.currentPickInfo.pickNumber,
                MHEID: this.state.currentPickInfo.mheId,
                RowName: this.state.currentPickInfo.rowName,
                PickDirection: this.state.currentPickInfo.pickDirection,
                PickOptions: this.state.currentPickInfo.pickOptions,
                NextPickType: nextPickType,
                StageID: pickStageId
            })
        };
        fetch('api/PaperlessPicking/GetNextPickLocation', nextPickRequest) //
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", pickData: result.data });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            });
    }

    verifyLocation() {
        var barCodeFormat = this.state.locationBarcode.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4) {
            this.setState({ locationVeficationMsg: "Invalid location barcode!! Barcode should be of this format : Stage-01-01-09" });
            this.refs.barcodeScanInput.focus();
            this.refs.barcodeScanInput.select();
            MySound.play(MySound.Sound.awhman);
            return;
        }
        //special requirement to prefix barcode segment with 0 if barcode segment length is 1 (1A-1-1-1 will be prefixed like 1A-01-01-01)
        this.state.locationBarcode = barCodeFormat[0] + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[1]) + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[2]) + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[3]);
        if (this.state.pickData.locationBarcode === this.state.locationBarcode) {
            this.setState({ locationBarcodeVerified: true, locationVeficationMsg: "" });
            this.updatePickTravelTime();
            MySound.play(MySound.Sound.next);
            this.goto('PickItem', { pickItem: this.state.pickData, pickOptions: this.state.currentPickInfo.pickOptions, pickDirection: this.state.currentPickInfo.pickDirection, selectedPickInfo: this.state.currentPickInfo.selectedPickInfo });
        }
        else {
            this.setState({ locationBarcodeVerified: false, locationVeficationMsg: "Next Location and Location Entered Must match to pick." });
            this.refs.barcodeScanInput.focus();
            this.refs.barcodeScanInput.select();
            MySound.play(MySound.Sound.awhman);
        }
    }

    prefixBarcodeSegmentWithZero(barCodeSegment) {
        if (barCodeSegment.length == 1) {
            barCodeSegment = "0" + barCodeSegment;
        }
        return barCodeSegment;
    }


    goBackToPickList() {
        this.updatePickTravelTime();
        if (this.state.isPickingShorts) {
            setTimeout(() => {
                //this.goto('ActivePicks', { nameCode: this.state.currentPickInfo.nameCode })
                this.goto('ShortedProducts', { selectedPick: this.state.currentPickInfo.selectedPick, pickOptions: this.state.currentPickInfo.pickOptions, backFromPickLocation: true, backPickData: this.state.currentPickInfo.pickData });
            }, 1000);
        }
        else {
            setTimeout(() => {
                this.goto('MHEWithPickRows', { selectedPick: this.state.currentPickInfo.selectedPickInfo })
            }, 1000);
        }

    }

    async skipLocation() {
        let userID = MyGlobal.user;
        this.setState({ loading: true, locationVeficationMsg: "" });
        const skipRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ PickData: this.state.pickData, PickOptions: this.state.currentPickInfo.pickOptions, userID: userID })
        };
        fetch('api/PaperlessPicking/SkipPickLocation', skipRequest) //
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = response.statusText;
                    this.setState({ alertMessage: result.errorMessage, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", });
                        MySound.play(MySound.Sound.next);
                        this.getNextPickLocation(this.nextLocation, this.state.pickData.stageID);
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            });
    }

    updatePickTravelTime() {
        let userID = MyGlobal.user;
        this.setState({ loading: true, locationVeficationMsg: "" });
        const updateTravelTimeRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ PickData: this.state.pickData, PickOptions: this.state.currentPickInfo.pickOptions, userID: userID })
        };
        fetch('api/PaperlessPicking/UpdatePickTravelTime', updateTravelTimeRequest) //
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = response.statusText;
                    this.setState({ alertMessage: result.errorMessage, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            });
    }

}

export default PickLocation;

